/**
 * 文件创建的时候，如果当前的菜单下面还有子菜单，需要在该文件夹下面新建一个 index.vue 的文件，用来跳转路由
 * 如果是该页面下的新增编辑页面，直接同级创建文件就行
 * 菜单命名的格式如下
 */
export const menus = [
    {
        key: "home",
        label: "首页",
        width: "320px",
        children: [
            {
                key: "about_feiyuan",
                label: "关于飞源",
                scrollTop:true
            },
            {
                key: "technical_services",
                label: "技术服务",
                scrollTop:true
            },
            {
                key: "our_clients",
                label: "我们的客户",
                scrollTop:true
            },
            {
                key: "message_centre",
                label: "资讯中心",
                scrollTop:true
            }
        ]
    },{
        key: "into",
        label: "走进飞源",
        width: "424px",
        children: [
            {
                key: "enterprise_profile",
                label: "企业简介",
                scrollTop:true            
            },
            {
                key: "development_history",
                label: "发展历程",
                scrollTop:true
            },
            {
                key: "enterprise_honor",
                label: "企业荣誉",
                scrollTop:true
            },
            {
                key: "enterprise_culture",
                label: "企业文化",
                scrollTop:true
            }
        ]
    },{
        key: "technical",
        label: "技术服务",
        width: "544px",
        children: [
            {
                key: "consultants",
                label: "环境咨询",
            },
            {
                key: "smart_ep",
                label: "智慧环保",
            }
        ]
    },{
        key: "news",
        label: "资讯中心",
        width: "664px",
        children: [
            {
                key: "enterprise_dynamics",
                label: "企业动态",
                scrollTop:true            
            },
            {
                key: "project_publicity",
                label: "项目公示",
                scrollTop:true
            }
        ]
    },{
        key: "join",
        label: "加入飞源",
        width: "786px",
        children: [
            {
                key: "talent_concept",
                label: "人才理念",
                scrollTop:true            
            },
            {
                key: "recruit_and_employ",
                label: "招贤纳士",
                scrollTop:true
            },
            {
                key: "contact_us",
                label: "联系我们",
                scrollTop:true
            }
        ]
    },
];
